// src/design-system/components/IceCard.jsx
import React from 'react';

/**
 * IceCard — Card branco gelo com texto escuro.
 * Uso: planos, tabelas de preço, cards de destaque sobre fundo escuro.
 *
 * @param {string}  className - Classes adicionais
 * @param {boolean} compact   - Padding reduzido
 * @param {boolean} elevated  - Shadow mais forte
 * @param {boolean} noHover   - Desabilita hover lift
 * @param {string}  as        - Tag HTML (default: 'div')
 * @param {node}    header    - Conteúdo do header
 * @param {node}    footer    - Conteúdo do footer
 */
export default function IceCard({
  children,
  className = '',
  compact = false,
  elevated = false,
  noHover = false,
  as: Tag = 'div',
  header,
  footer,
  style,
  ...props
}) {
  const cls = [
    'ds-ice-card',
    compact && 'ds-ice-card--compact',
    elevated && 'ds-ice-card--elevated',
    noHover && 'ds-ice-card--no-hover',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={cls} style={style} {...props}>
      {header && <div className="ds-ice-card__header">{header}</div>}
      <div className="ds-ice-card__body">{children}</div>
      {footer && <div className="ds-ice-card__footer">{footer}</div>}
    </Tag>
  );
}
